// @flow
import React from "react"
import withQuery from "hoc/withQuery"
import { type HOC } from "recompose"
import Page from "pages/_Page"
import { reservationDetailQuery } from "data/reservations/graphql/queries"
import { reservationStatuses } from "data/reservations/constants"
import { formatReadableDateRange } from "data/units/date/formatters"
import { PageTitle, FieldTitle } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import { Wrap } from "componentsStyled/Layout/Wrap"
import { VPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import {
  FixedBottom,
  FixedBottomSpacer,
} from "componentsStyled/Layout/FixedBottom"
import { HighlightedWrap, CancellationDetailsWrap } from "./styled"
import { Space } from "componentsStyled/Layout/Spacers"
import ProductPreview from "components/ProductPreview"
import ReservationPricingDetail from "components/ReservationPricing/ReservationPricingDetail"
import CancelReservation from "./CancelReservation"
import ExtendReservation from "./ExtendReservation"
import BuyIt from "./BuyIt"

const Reservation = ({ data }) => {
  const dates = {
    startDate: data.start,
    endDate: data.end,
  }

  const productGroupName = data.productItem.productVariant.product.productGroup.name

  return (
    <Page>
      <VPaddedFullWidthContainer narrow>
        <PageTitle>Reservation details</PageTitle>
        <Wrap stack>
          <ProductPreview
            productVariant={data.productItem.productVariant}
            affiliateName={data.productItem.affiliate.name}
          />
        </Wrap>
        <Wrap stack>
          <FieldTitle>Dates</FieldTitle>
          <Text>{formatReadableDateRange(dates)}</Text>
          <Space />
          <ExtendReservation reservation={data} />
        </Wrap>
        <Wrap stack>
          <FieldTitle>Store</FieldTitle>
          <Text>{data.productItem.affiliate.name}</Text>
        </Wrap>
        <Wrap stack>
          <FieldTitle>Address</FieldTitle>
          <Text>{data.productItem.affiliate.address}</Text>
        </Wrap>
        <HighlightedWrap stack>
          <FieldTitle>Reservation code</FieldTitle>
          <Text>{data.code}</Text>
        </HighlightedWrap>
        <Wrap stack>
          <ReservationPricingDetail
            {...data.pricingDetail}
            productGroupName={productGroupName}
          />
        </Wrap>
        {data.details.shippingAddress &&
          <Wrap>
            <Text uppercase bold black>
              Shipping Address
            </Text>
            <Text>
              {data.details.shippingAddress.split("\n").map((line) => {
                return <React.Fragment>
                  {line}<br />
                </React.Fragment>
              })}
            </Text>
          </Wrap>
        }
        <Wrap stack>
          <FixedBottom>
            <CancelReservation reservation={data} />
          </FixedBottom>
        </Wrap>

        {data.status === reservationStatuses.checked_out &&
          <Wrap stack>
            <BuyIt reservation={data} />
          </Wrap>
        }

        <CancellationDetailsWrap stack>
          <FieldTitle>CANCELLATION POLICY</FieldTitle>
          <Text>
            Flex Members pay for the first day of their booking if they don't
            cancel 48 hours prior to the start date. Perks Members can cancel
            for free up to 24 hours prior, after which they are also charged for
            that first day.
          </Text>
          <Space />
          <FieldTitle>LATE PICKUP POLICY</FieldTitle>
          <Text>
            If you don't pick up the gear by the end of the first day of the
            booking, the reservation will be canceled and you'll be charged the
            full price of the reservation.
          </Text>
          <Space />
          <FieldTitle>LATE DROP OFF POLICY</FieldTitle>
          <Text>
            For each day you're late, you'll be charged a late fee that's 2x the
            price of the first day of the booking. PRO TIP: Pending product
            availability, you can avoid late fees by simply extending your
            reservation.
          </Text>
        </CancellationDetailsWrap>
        <FixedBottomSpacer />
      </VPaddedFullWidthContainer>
    </Page>
  )
}

const enhancer: HOC<*, {||}> = withQuery(reservationDetailQuery)

export default enhancer(Reservation)



// WEBPACK FOOTER //
// ./src/pages/Reservation/index.js